import { memo, startTransition, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

/*
 * Keep high-frequency typing state out of the large Equipment/Flanges table
 * components. Refs stay current for synchronous submit validation/payloads,
 * while only this small subtree rerenders for each keystroke.
 */
const TicketModalTextFields = memo(function TicketModalTextFields({
  titleRef,
  descriptionRef,
  titleError,
  onClearTitleError,
  onTitlePresenceChange,
}) {
  const [title, setTitle] = useState(() => titleRef.current || "");
  const [description, setDescription] = useState(
    () => descriptionRef.current || "",
  );

  const handleTitleChange = (event) => {
    const nextTitle = event.target.value.slice(0, 255);
    const hadTitle = Boolean(title.trim());
    const hasTitle = Boolean(nextTitle.trim());

    titleRef.current = nextTitle;
    setTitle(nextTitle);

    if (hadTitle !== hasTitle && onTitlePresenceChange) {
      startTransition(() => onTitlePresenceChange(hasTitle));
    }
    if (titleError && onClearTitleError) {
      startTransition(onClearTitleError);
    }
  };

  const handleDescriptionChange = (event) => {
    const nextDescription = event.target.value;
    descriptionRef.current = nextDescription;
    setDescription(nextDescription);
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0.75,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, fontSize: "0.85rem" }}
          >
            Title <span style={{ color: "#d32f2f" }}>*</span>
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", fontSize: "0.7rem" }}
          >
            {title.length}/255
          </Typography>
        </Box>
        <TextField
          fullWidth
          size="small"
          placeholder="Brief description of the issue..."
          value={title}
          onChange={handleTitleChange}
          error={Boolean(titleError)}
          helperText={titleError}
          sx={{ "& .MuiInputBase-input": { fontSize: "0.875rem" } }}
        />
      </Box>

      <Box>
        <Typography
          variant="body2"
          sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
        >
          Description
        </Typography>
        <textarea
          className="remark-input ticket-modal-textarea"
          placeholder="Additional context, observations, steps to reproduce..."
          rows={3}
          value={description}
          onChange={handleDescriptionChange}
        />
      </Box>
    </>
  );
});

export default TicketModalTextFields;
